import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalDeletarEmpresa, setPageEmpresa } from "../redux/slices/empresa/empresaSlice";

export const cadastrarEmpresa = createAsyncThunk("/Empresa/CadastrarEmpresa", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/Empresa/CadastrarEmpresa", payload.value);
    toastSucess("Empresa cadastrada com sucesso");
    dispatch(setPageEmpresa("geral"));
    dispatch(setLoading(false));

    dispatch(buscarEmpresa(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error?.response?.data?.Message ?? "Erro ao processar a solicitação");
  }
});

export const buscarEmpresa = createAsyncThunk("/Empresa/BuscarEmpresa", async (pesquisar: string | null) => {
  try {
    const data = await api.get("/Empresa/BuscarEmpresa", {
      params: { pesquisar: pesquisar },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.Message ?? "Erro ao processar a solicitação");
  }
});

export const buscarTodasEmpresa = createAsyncThunk("/Empresa/BuscarTodasEmpresas", async (pesquisar: string | null) => {
  try {
    const data = await api.get("/Empresa/BuscarTodasEmpresas", {
      params: { pesquisar: pesquisar },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.Message ?? "Erro ao processar a solicitação");
  }
});

export const atualizarEmpresa = createAsyncThunk("/Empresa/AtualizarEmpresa", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Empresa/AtualizarEmpresa", payload.value);
    toastSucess("Empresa atualizada com sucesso");
    dispatch(setPageEmpresa("geral"));
    dispatch(setLoading(false));

    dispatch(buscarEmpresa(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error?.response?.data?.Message ?? "Erro ao processar a solicitação");
  }
});

export const atualizarEmpresaAtivo = createAsyncThunk("/Empresa/AtualizarStatusEmpresa", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Empresa/AtualizarEmpresaAtivo", null, {
      params: payload.value,
    });
    toastSucess("Status da empresa atualizado com sucesso");
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error?.response?.data?.Message ?? "Erro ao processar a solicitação");
  }
});

export const deletarEmpresa = createAsyncThunk("/Empresa/DeletarEmpresa", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/Empresa/DeletarEmpresa", {
      params: { id: payload.value },
    });
    toastSucess("Empresa removida com sucesso");
    dispatch(setModalDeletarEmpresa(false));
    dispatch(setLoading(false));

    dispatch(buscarEmpresa(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error?.response?.data?.Message ?? "Erro ao processar a solicitação");
  }
});
